import { LazyModule, LazyImport, createLazyComponent } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "PublicFolderPickerModule" */ './lazyIndex');
});
export var lazyLoadPublicFolders = new LazyImport(lazyModule, function (m) { return m.loadPublicFolders; });
export var LazyPublicFolderPicker = createLazyComponent(lazyModule, function (m) { return m.PublicFolderPicker; });
export var lazyRemovePublicFolderFromFavorites = new LazyImport(lazyModule, function (m) { return m.removePublicFolderFromFavorites; });
//# sourceMappingURL=index.js.map